import React from 'react';

export default function ErrorText() {
    return (
        <div className="error-text">
            This field cannot be blank.
        </div>
    )
}
